import {
  COURSE_LIST_ALL_FAIL,
  COURSE_LIST_ALL_REQUEST,
  COURSE_LIST_ALL_SUCCESS,
} from "../Constant/CourseConstant";

export const courseListAllRecReducer = (
  state = {},
  { type, payload, total }
) => {
  switch (type) {
    case COURSE_LIST_ALL_REQUEST: {
      return { loading: true };
    }

    case COURSE_LIST_ALL_SUCCESS: {
      return { loading: false, CouresesRec: payload, total };
    }

    case COURSE_LIST_ALL_FAIL: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};
export const SelectStudentPackageReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case "PACKAGE_SELECTED_REQ": {
      return { loading: true };
    }
    case "PACKAGE_SELECTED": {
      return {
        PackageData:  JSON.parse(localStorage.getItem("std-pack")) || payload,
      };
    }

    default:
      return state;
  }
};
